<template>
  <div>
    <v-data-table class="tableau" :items="listeCalendrierTable" :headers="colonnesTableau"
      v-on:click:row="ouvrirLienCalendrier">

      <template v-slot:[`item.nomCalendrier`]="{ item }">
        <div>
          <a class="text-decoration-underline">
            {{ item.nomCalendrier }}
          </a>
        </div>
      </template>

    </v-data-table>
  </div>
</template>

<script>
import useAppStore from '@/store/appStore';

export default {
  name: 'CSSParticipantesTable',
  components: {
  },
  setup() {
    const appStore = useAppStore();

    return { appStore };
  },
  data() {
    return {
      regexTypeFichier: new RegExp(/\.[^/.]+$/),
      listeCalendrierTable: [],
      listeCalendrierFichier: [
        "Offre régionale cours d'été en ligne Montérégie-Estrie 2025.pdf",
        "Calendrier - horaire cours d'été en ligne et épr. MEQ 2025 - Anglais 5e sec.pdf",
        "Calendrier - horaire cours d'été en ligne et épr. MEQ 2025 - Français 5e sec.pdf",
        "Calendrier - horaire cours d'été en ligne et épreuve MEQ 2025 - Histoire 4e sec.pdf",
        "Calendrier - horaire cours d'été en ligne et épreuve MEQ 2025 - Math 4e sec.pdf",
        "Calendrier - horaire cours d'été en ligne et épreuve MEQ 2025 - Sc. ST 4e sec.pdf",
        "Calendrier - horaire des cours d'été en ligne 2025 - Bloc A.pdf",
        "Calendrier - horaire des cours d'été en ligne 2025 - Bloc B - AM.pdf",
        "Calendrier - horaire des cours d'été en ligne 2025 - Bloc B - PM.pdf",
      ],
    };
  },
  async created() {
    // Obtention des CSS minimisés
    await this.gestionTableCalendrier();
  },
  methods: {
    ouvrirLienCalendrier(item) {
      window.open(`${this.appStore.modele.urlBase}/${item.lienFichierCalendrier}`);
    },
    async gestionTableCalendrier() {
      // Obtention des optionsCSS selon les CSS minimisés
      for (let cpt = 0; cpt < this.listeCalendrierFichier.length; cpt += 1) {
        const nomFichierActuel = this.listeCalendrierFichier[cpt];
        this.listeCalendrierTable.push({ nomCalendrier: nomFichierActuel.replace(this.regexTypeFichier, ''), lienFichierCalendrier: `pdf/${nomFichierActuel}` });
      }

      // Table mise en ordre alphabétique
      /* this.listeCSSParticipantes = this.listeCSSParticipantes.sort((a, b) => (a.nomCSS.toLowerCase() > b.nomCSS.toLowerCase()) ? 1 : ((b.nomCSS.toLowerCase() > a.nomCSS.toLowerCase()) ? - 1 : 0)); */
    },
  },
  computed: {
    colonnesTableau() {
      const colonnes = [
        {
          text: this.$tc('accueil.BoiteInfoGenerales.panneauExtension.calendrier'),
          align: 'start',
          sortable: false,
          value: 'nomCalendrier',
          width: '100%',
          class: 'grey lighten-4',
        },
      ];
      return colonnes;
    },
  },
};
</script>

<style scoped>
.tableau {
  margin-bottom: 12px;
}

.tableau::v-deep .v-data-footer,
.tableau::v-deep .row:last-child>.col>div:last-child,
.tableau::v-deep .row:first-child>div:first-child {
  display: none;
}

.tableau::v-deep .row:first-child>div:last-child {
  max-width: 100%;
  flex: 0 0 100%;
}

.tableau::v-deep .row:first-child {
  margin-bottom: -27px;
}

.tableau::v-deep tr {
  cursor: pointer;
}

.tableau::v-deep>div.row:last-child>div>div>div>table>tbody>tr>td {
  padding-top: 0px !important;
  padding-bottom: 0px !important;
}
</style>
